import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { getAccessToken } from "../../api/getAccessToken";
import {
  buildSportsbookKpisParams,
  parseSportsbookKpisResponse,
} from "./sportsbookAnalyticsKpisMapper";
import { SPORTSBOOK_ANALYTICS_PARAMS_SERIALIZER } from "./sportsbookAnalyticsFilterParams";
import type {
  SportsbookKpisQueryParams,
  SportsbookKpisResult,
} from "./sportsbookAnalyticsKpisTypes";

/**
 * Fetches the aggregate sportsbook KPIs (turnover, pnl, margin ratio) for the
 * currently applied filter state.
 */
export async function fetchSportsbookAnalyticsKpis(
  args: SportsbookKpisQueryParams,
): Promise<SportsbookKpisResult> {
  const { params, wasClamped } = buildSportsbookKpisParams(args);

  const instance = createPrivateAdminPanelInstance(getAccessToken());
  const response = await instance.get(
    API_ROUTES.GET_SPORTSBOOK_ANALYTICS_KPIS,
    {
      params,
      paramsSerializer: SPORTSBOOK_ANALYTICS_PARAMS_SERIALIZER,
    },
  );
  const parsed = parseSportsbookKpisResponse(response?.data);
  return { ...parsed, wasRangeClamped: wasClamped };
}
